import { RootState } from 'store';

export const selectClientPackageSchedules = ({ main }: RootState) => main.clientPackageSchedules.rows;

// True until the client's schedules have settled (idle before dispatch, or in-flight).
// Callers use this to avoid deriving a false "unlinked" state from an unloaded list.
export const selectClientPackageSchedulesLoading = ({ main }: RootState) =>
  main.clientPackageSchedules.loading === 'idle' || main.clientPackageSchedules.loading === 'pending';
export const selectClientPackageScheduleByPackageId = ({ main }: RootState, package_fixed_id: string | number) =>
  main.clientPackageSchedules.rows.find((item) => Number(package_fixed_id) === item.package.id);

export const selectLookupClientPackageSchedules = ({ main }: RootState) =>
  main.clientPackageSchedules.rows.map((item) => ({
    id: item.id,
    name: item.package.name,
  }));
